import { SaveForLaterSlideInPanelAnchorLocation } from "@redotech/redo-model/slide-in-panel/slide-in-panel-anchor-location";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getSaveForLaterStorefrontDisplaySettings = {
  name: "getSaveForLaterStorefrontDisplaySettings" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    enabled: z.boolean(),
    title: z.string(),
    message: z.string(),
    numViewedProductsUntilPanelOpen: z.number(),
    anchorLocation: createEnum(SaveForLaterSlideInPanelAnchorLocation),
  }),
};
